import React from 'react';

const Container = ({ 
  children,
  maxWidth = 'default',
  padding = 'md',
  className = '' 
}) => {
  const maxWidthClasses = {
    narrow: 'max-w-2xl',
    default: 'max-w-4xl',
    wide: 'max-w-6xl',
    full: 'max-w-full',
  };

  const paddingClasses = {
    none: 'p-0',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
  };

  return (
    <div className={`${maxWidthClasses[maxWidth]} ${paddingClasses[padding]} mx-auto ${className}`}>
      {children}
    </div>
  );
};

Container.builderConfig = {
  isContainer: true,
  props: {
    maxWidth: {
      type: 'select',
      label: 'Max Width',
      default: 'default',
      options: [
        { value: 'narrow', label: 'Narrow' },
        { value: 'default', label: 'Default' },
        { value: 'wide', label: 'Wide' },
        { value: 'full', label: 'Full Width' },
      ],
    },
    padding: {
      type: 'select',
      label: 'Padding',
      default: 'md',
      options: [
        { value: 'none', label: 'None' },
        { value: 'sm', label: 'Small' },
        { value: 'md', label: 'Medium' },
        { value: 'lg', label: 'Large' },
      ],
    },
  },
};

export default Container;
